export default "__VITE_ASSET__BHkH8wb7__"